// File: EVOLVE/Projects/cristTools/client/src/components/financial/FinancialPlanner.js
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const FinancialPlanner = () => {
  const [goal, setGoal] = useState('');
  const [amount, setAmount] = useState('');
  const [timeline, setTimeline] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add goal submission logic here
    console.log('Submitting financial goal:', { goal, amount, timeline });
  };

  return (
    <div className="p-4">
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-xl font-semibold mb-4">Set Financial Goals</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Goal Description</label>
            <input
              type="text"
              value={goal}
              onChange={(e) => setGoal(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Target Amount</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Timeline (months)</label>
            <input
              type="number"
              value={timeline}
              onChange={(e) => setTimeline(e.target.value)}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Set Goal
          </button>
        </form>
      </div>
    </div>
  );
};

export default FinancialPlanner;